import { brandSelectionLabel } from "../../lib/brand-identity";
import type { Brand } from "../../../../shared/types";

type Props = {
  brands: Brand[];
  value: string | undefined;
  onChange: (id: string) => void;
  className?: string;
  id?: string;
};

/** Native select — accessible, works on mobile and desktop. */
export function BrandSwitcher({ brands, value, onChange, className = "", id }: Props) {
  if (brands.length < 2) {
    return null;
  }

  return (
    <label htmlFor={id ?? "active-brand-select"} className={`block w-full min-w-0 ${className}`}>
      <span className="sr-only">Active brand</span>
      <select
        id={id ?? "active-brand-select"}
        className="w-full min-w-0 truncate rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm transition-colors focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-100"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {brands.map((b) => (
          <option key={b.id} value={b.id}>
            {brandSelectionLabel(b, brands)}
          </option>
        ))}
      </select>
    </label>
  );
}
